"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewRelic_1 = require("../integrations/NewRelic");
function logError(error) {
    NewRelic_1.nrNoticeError(error);
    console.error(error);
}
exports.logError = logError;
function logInfo(name, data) {
    console.info(name + ": ", data);
}
exports.logInfo = logInfo;
function logDebug(name, data) {
    console.debug(name + ": ", data);
}
exports.logDebug = logDebug;
function logAction(name, data) {
    NewRelic_1.nrAddPageAction(name, data);
    logDebug(name, data);
}
exports.logAction = logAction;
function logAttribute(name, value) {
    NewRelic_1.nrSetCustomAttribute(name, value);
    logInfo(name, value);
}
exports.logAttribute = logAttribute;
//# sourceMappingURL=Logger.js.map